import styled from "styled-components";

const Typography = styled.p`
  font-size: ${(props) => props.fontSize};
  font-family: ${(props) => props.fontFamily};
  font-weight: ${(props) => props.fontWeight};
  line-height: ${(props) => props.lineheight};
  color: ${(props) => {
    if (props.color) {
      return props.color;
    }
    return `var(--highlight)`;
  }};
  text-decoration: ${(props) => props.textDecoration};
  cursor: ${(props) => props.cursor};
  margin: ${(props) => props.margin};
  padding: ${(props) => props.padding};
  text-align: ${(props) => props.textalign};
`;

const Text = ({
  children,
  fontSize,
  fontFamily,
  fontWeight,
  lineheight,
  color,
  textDecoration,
  cursor,
  margin,
  padding,
  textalign,
}) => {
  return (
    <Typography
      fontSize={fontSize}
      fontFamily={fontFamily}
      fontWeight={fontWeight}
      lineheight={lineheight}
      textDecoration={textDecoration}
      color={color}
      cursor={cursor}
      margin={margin}
      padding={padding}
      textalign={textalign}
    >
      {children}
    </Typography>
  );
};

export default Text;
